import Collapse from "@material-ui/core/esm/Collapse";
import Box from "@material-ui/core/esm/Box";
import CloseIcon from "@material-ui/icons/esm/Close";
import clsx from 'clsx';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EditButton, SecondaryButton } from 'components/Button';
import ExpandButton from 'components/Button/ExpandButton';
import { Title } from 'components/Text';
import VehicleIcon from 'components/VehicleIcon/VehicleIcon';
import VehicleInfo from 'components/VehicleInfo/VehicleInfo';
import useStyles from './VehicleDetailCardStyles';
export default function VehicleDetailCard({
  children,
  vehicle,
  hasBorder,
  onRemoveText,
  showVehicleIcon,
  onRemove,
  onEdit,
  tagOption,
  hasHelperText
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const handleExpandClick = () => setIsExpanded(!isExpanded);
  const {
    t
  } = useTranslation();
  const {
    vehicleDetailCardBorder,
    titleAndAgreementName,
    noRegBox,
    smallerMarginTop
  } = useStyles();
  const registrationNumber = vehicle?.registrationNumber;
  return /*#__PURE__*/React.createElement(Box, {
    my: 2,
    className: clsx({
      [vehicleDetailCardBorder]: hasBorder,
      [smallerMarginTop]: hasHelperText
    })
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    mt: 2,
    ml: 1,
    justifyContent: "space-between",
    alignItems: "center",
    alignContent: "space-between"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(VehicleIcon, {
    vehicle: registrationNumber ? vehicle : undefined
  }), /*#__PURE__*/React.createElement(Box, {
    className: titleAndAgreementName,
    ml: 2
  }, /*#__PURE__*/React.createElement(Title, {
    hasNoSpacing: true
  }, registrationNumber || t('vehicles.no_attached_vehicle')), vehicle?.agreementName && /*#__PURE__*/React.createElement("div", null, `${t('agreements.agreement_name')}: ${vehicle.agreementName}`), tagOption && /*#__PURE__*/React.createElement("div", null, `${t('unregister_vehicle.tag_option_title')}: ${tagOption}`))), onEdit && /*#__PURE__*/React.createElement(EditButton, {
    onClick: onEdit,
    outlined: false
  }, t('register_vehicle.edit_vehicle'))), vehicle && registrationNumber ? /*#__PURE__*/React.createElement(Box, {
    mx: 2
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExpandButton, {
    onClick: handleExpandClick,
    isExpanded: isExpanded
  }), /*#__PURE__*/React.createElement(Collapse, {
    in: isExpanded,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(VehicleInfo, {
    showVehicleIcon: showVehicleIcon,
    vehicle: vehicle
  }))))) : /*#__PURE__*/React.createElement(Box, {
    className: noRegBox
  }), onRemove && /*#__PURE__*/React.createElement(SecondaryButton, {
    outlined: false,
    onClick: onRemove,
    startIcon: /*#__PURE__*/React.createElement(CloseIcon, null)
  }, onRemoveText || t('register_vehicle.remove_vehicle')), children);
}
VehicleDetailCard.defaultProps = {
  children: null,
  onRemove: null,
  onEdit: null,
  showVehicleIcon: true,
  hasHelperText: false,
  hasBorder: false,
  onRemoveText: '',
  tagOption: ''
};